import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, SimpleChanges, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { CategoryModel } from '@core/models/categories';
import { SkuResult, SubCategoryResult } from '@core/services/api.service';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-categories',
    templateUrl: './categories.component.html',
    styleUrls: ['./categories.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class CategoriesComponent implements OnInit, OnChanges {
    @Input() categories: SubCategoryResult[];
    @Input() isLoading: boolean;
    @Output() productCategoryFilter = new EventEmitter<any>();
    @Output() catProdFilter = new EventEmitter<{ category: string, subCategory: string, subCategory3: string, subCategory4: string }>();
    returnUrl: string;
    currentUrl: any;
    productByCategory$: Observable<SkuResult>;
    sortedCategories: SubCategoryResult[]
    isDrawerOpen: boolean = false; // Track drawer state
    selectedCategory: CategoryModel; // Store the selected category
    categorySelected: string = '';
    subCategorySelected: string = '';
    subCategory2Selected: string = '';
    subCategory3Selected: string = '';
    subCategory4Selected: string = '';

    constructor(
        private store: Store,
        private router: Router
    ) {

    }

    ngOnInit() {
        this.currentUrl = this.router.url;
        this.currentUrl = window.location.pathname;
        this.router.routerState.root.queryParams.subscribe(params => {
            this.categorySelected = params['category'] || null;
            this.subCategorySelected = params['subCategory'] || null;
            this.subCategory2Selected = params['subCategory2'] || null;
            this.subCategory3Selected = params['subCategory3'] || null;
            this.subCategory4Selected = params['subCategory4'] || null;
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.categories && changes.categories.currentValue) {
            this.sortedCategories = [...this.categories]
            // this.sortedCategories.sort((x, y) => x.subCategory.localeCompare(y.subCategory))

            setTimeout(() => {
                var toggler = document.getElementsByClassName("caret");
                var i;

                for (i = 0; i < toggler.length; i++) {
                    toggler[i].addEventListener("click", function () {
                        this.parentElement.querySelector(".nested").classList.toggle("active");
                        this.classList.toggle("caret-down");
                    });
                }

            }, 120);
        }
    }

    toggleDrawer(category: CategoryModel) {
        this.selectedCategory = category; // Store the selected category
        this.isDrawerOpen = !this.isDrawerOpen; // Toggle the drawer state
    }

    onClick(event: Event) {
        event.preventDefault();
    }

    getProductCategory(category: string, subCategory: string, subCategory3: string, subCategory4: string) {
        this.catProdFilter.emit({ category, subCategory, subCategory3, subCategory4 });
       // this.isDrawerOpen = false; // Close the drawer after selecting an item
    }

    clearCategory() {
        this.catProdFilter.emit();
        this.isDrawerOpen = false; // Close the drawer after selecting an item
    }
}
